/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'
import UiEmptyState from 'components/Ui/UiEmptyState'

type UiTableEmptyRowProps = {
    colSpan: number
    title: React.ReactNode
    description?: React.ReactNode
    icon?: React.ReactNode
    className?: string
}

const UiTableEmptyRow: React.FC<UiTableEmptyRowProps> = ({
    colSpan,
    title,
    description,
    icon,
    className,
}) => {
    return (
        <tr
            className={clsx(
                'UiTableEmptyRow bg-white/80 h-full',
                'dark:bg-gray-900/80'
            )}
        >
            <td
                className={clsx('px-6 py-10 text-center h-full align-middle', className)}
                colSpan={colSpan}
            >
                <div className="flex flex-col items-center justify-center h-full min-h-[100px]">
                    <UiEmptyState
                        icon={icon}
                        title={title}
                        description={description}
                    />
                </div>
            </td>
        </tr>
    )
}

export default UiTableEmptyRow
